import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { expandCollapse } from '../../animations/expandCollapse';
import { NavLinksWithIcon, SubNavLinksWithIcon } from '../navigation';

@Component({
  selector: 'to-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: expandCollapse
})
export class SideNavComponent {
  @Input() prod = window.location.pathname.indexOf('TechOpsAppsStage') === -1;
  @Input() navBar: NavLinksWithIcon[];
  trackNav = (index: number, item: NavLinksWithIcon) => item.path;
  trackSubNav = (index: number, item: SubNavLinksWithIcon) => item.path;
}
